
import { gsap } from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';
gsap.registerPlugin(ScrollTrigger);
export default {
  init() {
      gsap.to('.navbar',{
        scrollTrigger: {
          trigger: ".global-main",
          start: "50px", 
          endTrigger:"html", end:"bottom top",
          toggleActions: 'play reverse none reverse',
          toggleClass: {targets: '.navbar', className: "gradient-bg"}
        }
    
      });


    gsap.set('.anim-circle', {y:-400});
    gsap.to('.anim-circle',{
      scrollTrigger : {
        trigger : '#block-intro-cta',
        start: 'top center',
      },
      y:0
    });
  },
  finalize() {}
}